import { createContext, useContext } from 'react';

export interface SectionContextValue {
  expanded: boolean;
  onToggle: () => void;
  registerSectionMetadata?: RegisterSectionMetadata;
}

export type SectionMetadata = {
  title: string;
};

export type RegisterSectionMetadata = (metadata: SectionMetadata) => () => void;

export const SectionContext = createContext<SectionContextValue | undefined>(
  undefined,
);

export const useOptionalSectionContext = () => useContext(SectionContext);

export const useSectionContext = () => {
  const context = useOptionalSectionContext();
  if (!context) {
    throw new Error(
      'Section compound components must be used within Section.Root',
    );
  }
  return context;
};
